import { Tab } from '@mui/material';
import RegistrationManage from './RegistrationManage';
import AttendanceManage from './AttendanceManage';
import LoadingSpinner from '../../../../../animation/LoadingSpinner';
import useRegistration from './hooks/useRegistration';
import NotFound from '../../../../../pages/404/NotFound';
import '../../../../../styles/components/CreateEvent.css';

export default function Registration() {

    const { activeTab, setActiveTab, loading, error } = useRegistration();

    if (error) {
        return (
            <NotFound
                statusCode={error?.code}
                pageTitle="Error Fetching Registrations"
                description="There was an error while fetching the registrations. Please try again later."
                shouldShowBgGradient={false}
            />
        );
    }

    return (
        <section id="create-event-tickets-section">
            <div className="event-creation-stepper">
                <Tab
                    label="Attendees List"
                    variant={activeTab === 'attendees' ? 'main' : 'inactive'}
                    onClick={() => setActiveTab('attendees')}
                />
                <Tab
                    label="Attendance"
                    variant={activeTab === 'attendance' ? 'main' : 'inactive'}
                    onClick={() => setActiveTab('attendance')}
                />
            </div>
            <div className="event-creation-tabs-content">
                {activeTab === 'attendees' && <RegistrationManage parentLoading={loading} />}
                {activeTab === 'attendance' && <AttendanceManage parentLoading={loading} />}
            </div>
        </section>
    );
}